module.exports = __webpack_public_path__ + "static/img/s-local-3.19de88c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-local-3.png
// module id = e5Td
// module chunks = 1